<div *ngFor="let ost of osts" class="ras-snackbar-line">
    {{ost.name}}
    <ng-container *ngFor="let fruizione of ost.fruizione">
        <i (ngClass)="classForFruizione(fruizione)"></i>
    </ng-container>
</div>